import React, { useRef } from 'react';

import { ShareCollectionContentOverlay } from 'components/ShareCollectionContentOverlay';
import { IBrandContent } from 'common';
import DeleteIcon from '@mui/icons-material/Delete';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';

import Draggable from 'components/Draggable';
import { ShareInfo } from '@src/types/share';
import { DownloadHelper } from '@src/services/helpers/download';
import styles from './styles.module.scss';

interface IProps {
  content: IBrandContent
  onShare: (info: ShareInfo) => any
  onDelete: () => void
}

export function BrandContent({ content, onShare, onDelete }: IProps) {
  const downloading = useRef(false);

  function handleShare() {
    onShare({
      image: content.urls.thumbnail,
      file: content.urls.file,
      fileType: content.type,
      _id: content._id,
    });
  }

  async function download(c: IBrandContent) {
    if (downloading.current) {
      return;
    }
    downloading.current = true;
    const fileUrl = toBucketDomain(c.urls.file);
    const file = await DownloadHelper.downloadBrandContentMedia(fileUrl, c._id);

    if (file) {
      DownloadHelper.triggerDownload(file.fileUrl);
    }
  }

  return (
    <Draggable
      className="thumbnail"
      style={{ backgroundImage: `url("${content.urls.thumbnail}")` }}
      info={{
        origin: 'share',
        type: 'brandcontent',
        content: content,
      }}
    >
      {content.type === 'video'
        ? (
        <div className="play-button">
          <PlayArrowRoundedIcon
            style={{ fontSize: '5rem', margin: 'auto' }}
          />
        </div>
        ) : null
      }
      <ShareCollectionContentOverlay
        onShare={handleShare}
        onDownload={() => download(content)}
        isBrandContent={true}
      >
        <DeleteIcon className={styles.delete} onClick={onDelete} />
      </ShareCollectionContentOverlay>
    </Draggable>
  );
}

// transform a URL like storage.googleapis.com/my-bucket to my-bucket.storage.googleapis.com
// Otherwise, CORS headers won't be present in the response
function toBucketDomain(gcsUrl: string): string {
  if (!gcsUrl.startsWith('https://storage.googleapis.com')) {
    return gcsUrl;
  }

  return gcsUrl.replace(
    /^https:\/\/storage.googleapis.com\/([^/]+)/,
    'https://$1.storage.googleapis.com',
  );
}
